const PasswordResetSent = () => {
  return (
    <div className="container">
      <h1>Password Reset Email Sent</h1>
      <p>
        A password reset email has been sent to your email address. Please check
        your inbox (and spam folder) for the password reset email.
      </p>
    </div>
  );
};

export default PasswordResetSent;
